<template>
  <div class='price-page'>
    <div class='banner'>
      <div>
        <div>
          <h3>公有云部署 ——</h3>
          <p>每月<span>10000</span>分钟免费，<span>0</span>启动成本。单价行业内最低！小程序端<span>限免</span>！</p>
          <h3 style='margin-top: 10px;'>私有化部署 ——</h3>
          <p>请联系 <span>400-646-1860</span> 获取详细报价</p>
          <button class='button' @click='redirectConsole'>立即体验</button>
        </div>
        <img src='../assets/price-banner.png'/>
      </div>
    </div>
    <div class='center'>
      <price-section
        v-for='(item, index) in prices'
        :key='index'
        :title='item.title'
        :moreTip='item.moreTip'
        :data='item.data'>
      </price-section>
    </div>
  </div>
</template>

<script>
import PriceSection from '../components/price.vue';
import { CONSOLE_SITE_URL } from '../utils/constants';

export default {
  metaInfo: {
    title: '实时音视频PaaS服务-0启动成本-马兰头医学科技',
    meta: [
      {
        name: 'keywords',
        content: 'webrtc,公有云,私有云,实时音视频,小程序,实时通信,免费视频通话,互动白板,互动直播'
      },
      {
        name: 'description',
        content: '马兰头医学科技新一代实时音视频通信平台，4行代码即可快速搭建应用。高度组件化、高度模块化。10年+技术探索与积淀，研发独有的编解码核心技术，成就业内领先极低时延的音视频专家'
      },
    ]
  },
  name: 'Price',
  components: {
    PriceSection,
  },
  data() {
    return {
      prices: [
        {
          title: '音视频',
          data: [
            { name: '音频', value: '6', unit: '元/千分钟' },
            { name: '标清视频SD（分辨率≤360P）', value: '13', unit: '元/千分钟' },
            { name: '高清视频HD（360P＜分辨率≤720P）', value: '25', unit: '元/千分钟' },
            { name: '超高清视频HD+（720P＜分辨率≤1080P）', value: '96', unit: '元/千分钟' },
          ],
        },
        {
          title: 'RTMP推流',
          data: [
            { name: '音频', value: '8', unit: '元/千分钟' },
            { name: '标清视频SD（分辨率≤360P）', value: '32', unit: '元/千分钟' },
            { name: '高清视频HD（360P＜分辨率≤720P）', value: '43', unit: '元/千分钟' },
            { name: '超高清视频HD+（720P＜分辨率≤1080P）', value: '216', unit: '元/千分钟' },
          ],
        },
        {
          title: '云端录制',
          data: [
            { name: '音频', value: '8', unit: '元/千分钟' },
            { name: '标清视频SD（分辨率≤360P）', value: '22', unit: '元/千分钟' },
            { name: '高清视频HD（360P＜分辨率≤720P）', value: '32', unit: '元/千分钟' },
            { name: '超高清视频HD+（720P＜分辨率≤1080P）', value: '119', unit: '元/千分钟' },
          ],
        },
        {
          title: '更多折扣及私有化部署',
          moreTip: true
        },
      ]
    }
  },
  methods: {
    redirectConsole() {
      window.open(CONSOLE_SITE_URL);
    },
  },
}
</script>

<style lang="less" scoped>
.price-page {
  padding-bottom: 80px;
  .banner {
    background: linear-gradient(134deg,#2544a1 3%, #152664 96%);
    padding-bottom: 20px;
    >div {
      display: flex;
      width: 1149px;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      h3 {
        font-size: 30px;
        color: #FFFFFF;
        font-weight: 600;
        margin-bottom: 5px;
      }
      p {
        font-size: 21px;
        color: #FFFFFF;
        line-height: 29px;
        span {
          color: #FFD900;
        }
      }
      .button {
        width: 140px;
        margin-top: 20px;
        font-size: 16px;
      }
    }
  }
  .center {
    width: 1150px;
    margin: 40px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .price-component {
      margin-bottom: 50px;
    }
    .more {
      margin-top: 60px;
      text-align: center;
      background: #ffffff;
      box-shadow: 0px 2px 16px 3px rgba(59,113,241,0.11);
      .title {
        height: 80px;
        line-height: 80px;
        background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
        border-radius: 10px 10px 0 0;
        text-align: center;
        color: #fff;
        font-weight:600;
        font-size: 24px;
      }
      .text1 {
        font-size: 36px;
        font-weight: 600;
        color: #3b71f2;
        line-height: 50px;
      }
      .text2 {
        font-size: 24px;
        font-weight: 400;
        color: #3b71f1;
        line-height: 33px;
        margin-top: 10px;
        span {
          color: #f00;
        }
      }
    }
  }
  .button {
    margin-top: 30px;
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(325deg,#f2a73b 7%, #ffcb8d 95%);
    border-radius: 25px;
    border: none;
    outline: none;
    font-size: 21px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>